module.exports = __webpack_public_path__ + "img/trainee-planning-white.82df72f0.svg";